import { getWebInstrumentations, initializeFaro, type Faro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { API_BASE } from './api'

// Grafana Frontend Observability: web vitals, errors, sessions, and browser
// traces that propagate `traceparent` to the API so a click in the store and
// its backend spans are one trace.
export let faro: Faro | undefined

export function initFaro() {
  const url = import.meta.env.VITE_FARO_URL as string | undefined
  if (!url) return
  faro = initializeFaro({
    url,
    app: { name: 'Ensemble Storefront', version: '1.0.0', environment: (import.meta.env.VITE_FARO_ENV as string) || 'production' },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation({
        instrumentationOptions: { propagateTraceHeaderCorsUrls: [new RegExp('^' + API_BASE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))] },
      }),
    ],
  })
}

export function faroEvent(name: string, attrs: Record<string, string> = {}) {
  faro?.api.pushEvent(name, attrs)
}
